module.exports = __webpack_public_path__ + "static/img/3.38f93eab.jpg";